import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { AppMainService } from 'src/app/app-main.service';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { Subject, takeUntil } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AccountsTransactionType, Channel, RoutingPath, typeJournalAddEditText } from 'src/app/finance/constants/constants';
import { Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { FinanceUtilityService } from 'src/app/finance/util/finance-utility.service';
import { ImportserialService } from '../../services/importserial.service';


@Component({
    selector: 'app-purchase-history',
    templateUrl: './purchase-history.component.html',
})

export class PurchaseHistoryComponent implements OnInit,OnChanges {

    @Input() purchaseHistory;
    @Input() searchValuePurchase;
    @Input() noPurchaseFindOrLoadingText;
    @Input() totalRecordPurchase: number=0;
    @Input() module;
   
    @Output() getPurchaseHistory = new EventEmitter();
    length: number = 0;
    qtyDecimal: number = 0;
    pageNumber: number = 1;
    pageSize: number = 15;
    rowsPerPage = [15, 30, 50, 100];
    isView: boolean = true;
    // displayBillDetail: boolean = false;
    // billDetails
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    // billPaymentDetails;
    displayOverview: boolean = false;
    // poDetails;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";
    // rpoDetails;
    journalViewObj: any;
    autoGenerateLists = [];
    savedOptionSelection=null;
    displayScanInfo: boolean = false;
    nameLists = [];
    totalTBRecord: number =0;
    rowsPerPageTB = [100, 200, 300, 500];
    first: number=0;
    @Output() onClosefullAddEdit = new EventEmitter<typeJournalAddEditText>();
    @Output() onSuccessfullAddEdit = new EventEmitter<typeJournalAddEditText>();
    trackingOptions = [];
    utilityService: FinanceUtilityService;
    @Output() openLocationDialog = new EventEmitter<number>();
    @Output() openVendorDialog = new EventEmitter<number>();
    
    

    constructor(private appMainService: AppMainService,private purchaseService: PurchasesService,private messageService: MessageService,
        private utilService: FinanceUtilityService,private importService: ImportserialService,
        private router: Router,private app: AppMainComponent,
    ){ }

    ngOnInit(): void {
      this.utilityService = this.utilService;
      this.importService.getDecimalValue().subscribe(value => {
        if(value){
          this.length = value;
        }
      })
      this.importService.getQtyDecimalValue().subscribe(value => {
        if(value){
          this.qtyDecimal = value;
        }
      })
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes.purchaseHistory && changes.purchaseHistory.currentValue) {
          this.getAllOrgTrackingOptions();
      }
  }

    searchFilter(){
        const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize,value: this.searchValuePurchase}
        this.getPurchaseHistory.emit(obj);
    }
    onPageChange(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.pageSize = event.rows;
        const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize,value: this.searchValuePurchase}
        this.getPurchaseHistory.emit(obj);
    }

    onRouteNavigation(e, str) {
      this.journalViewObj = e;
  
      if (str === 'location') return this.openLocationDialog.emit(e.warehouseId);
      if (str === 'vendor') return this.openVendorDialog.emit(e.vendorId);
  
      let refId, refNumber, module;
      if (this.journalViewObj.txnTypeId === AccountsTransactionType.ItemReceipt && str === "Bill") {
          refId = e.billOrderId;
          refNumber = e.rpoId;
          module = "Bill";
      } else if (this.journalViewObj.txnTypeId === AccountsTransactionType.Bill && str === "Bill") {
          refId = e.billOrderId;
          refNumber = e.billId;
          module = "Bill";
      } else if (str === 'PO') {
          refId = e.purchaseOrderId;
          refNumber = e.poId;
          module = "PurchaseOrder";
      }
  
      if (refId && refNumber) {
          this.inventoryOverviewRefId = refId;
          this.inventoryOverviewRefNumber = refNumber;
          this.inventoryOverviewModule = module;
          this.displayInventoryOverview = true;
      }
  
  }
  

      //** serialNo tracking**//
      getAllOrgTrackingOptions(){
        this.purchaseService.loadTrackingOptions().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((options) => {
            this.trackingOptions = options;
         })
    }

    showSerialDetails(product, type) {
        this.savedOptionSelection = product.serialSettings;
        this.displayScanInfo = true;
        this.nameLists = [];
        this.autoGenerateLists = [];
        const arr = [];
        if (type == 'receipt' ) {
          this.purchaseService.getItemReceiptProductSerialDetails(product.rpoId, product.productId, (product.type == 'product' ? 0 : product.subProductId)).subscribe(res => {
            res?.forEach((element) => {
              const obj = {
                id: element.id,
                serialNo: element.barcode,
                serialNo2: element.serialNumber2,
                serialNo3: element.serialNumber3,
                serialNo4: element.serialNumber4,
                serialNo5: element.serialNumber5,
                serialNo6: element.serialNumber6,
                serialNo7: element.serialNumber7,
                serialNo8: element.serialNumber8,
                serialNo9: element.serialNumber9,
                serialNo10: element.serialNumber10,
                serialNo11: element.serialNumber11,
                serialNo12: element.serialNumber12,
                serialNo13: element.serialNumber13,
                serialNo14: element.serialNumber14,
                serialNo15: element.serialNumber15,
                serialNo16: element.serialNumber16,
                serialNo17: element.serialNumber17,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: this.app._showDateTimeWithZone(element.expirationDate)
              }
              arr.push(obj);
            });
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.totalTBRecord = this.autoGenerateLists?.length;
          })
        } else {
          this.purchaseService.getBillProductSerialDetails(product.billOrderId, product.productId, (product.type == 'product' ? 0 : product.subProductId)).subscribe(res => {
            res?.forEach((element) => {
              const obj = {
                id: element.id,
                serialNo: element.barcode,
                serialNo2: element.serialNumber2,
                serialNo3: element.serialNumber3,
                serialNo4: element.serialNumber4,
                serialNo5: element.serialNumber5,
                serialNo6: element.serialNumber6,
                serialNo7: element.serialNumber7,
                serialNo8: element.serialNumber8,
                serialNo9: element.serialNumber9,
                serialNo10: element.serialNumber10,
                serialNo11: element.serialNumber11,
                serialNo12: element.serialNumber12,
                serialNo13: element.serialNumber13,
                serialNo14: element.serialNumber14,
                serialNo15: element.serialNumber15,
                serialNo16: element.serialNumber16,
                serialNo17: element.serialNumber17,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: this.app._showDateTimeWithZone(element.expirationDate)
              }
              arr.push(obj);
            });
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.totalTBRecord = this.autoGenerateLists?.length;
          })
        }
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
          this.nameLists = this.autoGenerateLists.slice(
            event.first,
            event.first + event.rows
          );
        }
      }

    reloadBillDetails() { 
        const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize,value: this.searchValuePurchase}
        this.getPurchaseHistory.emit(obj);
    }


    showErrorMsg(err) {
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
        });
    }
    closeViewPopup() {
        this.displayInventoryOverview = false;
    }
    updateJournalList(e: typeJournalAddEditText) {
        this.displayOverview = false;
        this.isView = true;
        this.onSuccessfullAddEdit.emit(e);
    }
    closeJournalList() {
        this.displayOverview = false;
        this.isView = true;
        this.onClosefullAddEdit.emit();
    }


    navigateToDetails(str) {
        const key = str ;
        this.onDialogClose();
        this.router.navigate([RoutingPath[key]], {
            queryParams: {
                id: str == "ItemReceipt" ? this.journalViewObj?.rpoId : this.journalViewObj.billOrderId,
                module: str == "ItemReceipt" ? "ItemReceipt" : "Bill",
                channelId: Channel[key],
                statusId: 1,
                globalSearch: true,
                data: this.journalViewObj?.billId,
            },
        });
    }
    onDialogClose() {
        this.displayOverview = false;
    }
}



